import React from 'react';
import './Livestream.css';

function Livestream() {
  return (
    <div className="livestream-section">
      <div className="livestream-header">
        <h2>🔴 Live Market Stream</h2>
        <p>Join us live as we showcase the latest African fashion and textiles from various markets</p>
      </div>

      <div className="livestream-container">
        <div className="livestream-player">
          <div className="stream-placeholder">
            <iframe
              src="https://twitch.tv/embed/afrostripes/chat?parent=localhost"
              height="500"
              width="100%"
              frameBorder="0"
              scrolling="no"
              allowFullScreen="true"
              title="Twitch Chat"
            ></iframe>
          </div>
          <div className="twitch-embed">
            <iframe
              src="https://twitch.tv/embed/afrostripes/chat?parent=localhost"
              height="600"
              width="100%"
              frameBorder="0"
              scrolling="no"
              allowFullScreen="true"
              title="Twitch Stream"
            ></iframe>
          </div>
        </div>

        <div className="livestream-info">
          <div className="info-card">
            <h3>🎬 Live Showcase</h3>
            <p>Watch live demonstrations of authentic African attire, textiles, and fashion designs directly from various African markets.</p>
          </div>

          <div className="info-card">
            <h3>💬 Interactive Chat</h3>
            <p>Connect with our community in real-time. Ask questions, share your thoughts, and make purchases while watching.</p>
          </div>

          <div className="info-card">
            <h3>🛍️ Shop Live</h3>
            <p>Purchase items directly during the livestream. Special discounts and limited-time offers available exclusively for live viewers.</p>
          </div>

          <div className="info-card">
            <h3>📅 Schedule</h3>
            <p>Monday - Friday: 6 PM - 8 PM EST | Saturday: 2 PM - 6 PM EST | Sunday: 4 PM - 7 PM EST</p>
          </div>

          <div className="twitch-link-section">
            <h3>Visit our Twitch Channel</h3>
            <a
              href="https://twitch.tv/afrostripes"
              target="_blank"
              rel="noopener noreferrer"
              className="twitch-btn"
            >
              🎮 Go to Twitch Channel
            </a>
            <p className="instruction-text">
              Replace "your_channel_name" with your actual Twitch channel name in the code to enable live streaming.
            </p>
          </div>
        </div>
      </div>

      <div className="market-info">
        <h3>Featured Markets This Week</h3>
        <div className="markets-grid">
          <div className="market-item">
            <h4>Lagos Market 🇳🇬</h4>
            <p>Traditional Ankara and Wax prints from Nigeria's largest textile hub</p>
          </div>
          <div className="market-item">
            <h4>Accra Central 🇬🇭</h4>
            <p>Premium Kente cloth and kente-inspired modern fashion</p>
          </div>
          <div className="market-item">
            <h4>Dakar Soumbedioune 🇸🇳</h4>
            <p>Vibrant Senegalese textiles and traditional wear</p>
          </div>
          <div className="market-item">
            <h4>Nairobi Craft Center 🇰🇪</h4>
            <p>Handmade beaded jewelry and leather accessories</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Livestream;
